import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import clsx from 'clsx';

import axiosInstance from '../../config/axiosConfig';
import useUserStore from '../../store/useUserStore';
import useSelectedCompanyStore from '../../store/useSelectedCompanyStore';

const CompanyJoinDialog = () => {
    const location = useLocation();
    const toast = useRef(null);

    const selectedCompany = useSelectedCompanyStore((state) => state.selectedCompany);
    const clearCompanies = useUserStore((state) => state.clearCompanies);

    const queryParams = new URLSearchParams(location.search);
    const urlInvitationCode = queryParams.get('invitation_code');

    const [invitationCode, setInvitationCode] = useState('');
    const [joinLoading, setJoinLoading] = useState(false);

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!selectedCompany) return;

        if (urlInvitationCode) {
            setInvitationCode(urlInvitationCode);
            setVisible(true);
        }
    }, [urlInvitationCode]);

    const handleJoin = () => {
        if (invitationCode.length !== 8) {
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Le code d\'invitation doit comporter 8 caractères.', life: 10000 });
            return;
        }

        setJoinLoading(true);

        axiosInstance.post(`/dashboard/companies/invitations/${invitationCode}/accept`).then(response => {
            toast.current.show({ severity: 'success', summary: 'Succès', detail: `Vous avez rejoint avec succès: ${response.data.company_name}`, life: 10000 });

            // This forces a refresh
            clearCompanies();

            setTimeout(() => {
                window.location.href = "/dashboard/company/create";
            }, 1000);

        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Erreur, votre code a peut-être expiré.', life: 10000 });
        }).finally(() => {
            setJoinLoading(false);
        });
    };

    const hideDialog = () => {
        setVisible(false);
    };

    const footerContent = (
        <div className="columns mt-3">
            <div className="column has-text-left">
                <button className="button" disabled={joinLoading} onClick={hideDialog}>
                    Retour
                </button>
            </div>

            <div className="column has-text-right">
                <button
                    className={clsx("button is-info is-outlined", { 'is-loading': joinLoading })}
                    onClick={handleJoin}
                >
                    Rejoindre
                </button>
            </div>

        </div>
    );

    return (
        <>
            <Toast ref={toast} position="bottom-right" />

            <Dialog
                visible={visible}
                onHide={hideDialog}
                header="Rejoindre une Entreprise"
                footer={footerContent}
                style={{ width: 550 }}
                dismissableMask={true}
                modal
            >
                <p style={{ fontSize: '12px' }} className='mb-5 mt-0'>Veuillez entrer un code à 8 caractères fourni par votre entreprise</p>
                <div className="field">
                    <label className="label" htmlFor="invitationCode">Code d'invitation</label>
                    <div className="control">
                        <input
                            className="input"
                            id="invitationCode"
                            value={invitationCode}
                            onChange={(e) => setInvitationCode(e.target.value)}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default CompanyJoinDialog;